import { render } from "./ManageSubscription.vue?vue&type=template&id=55c3865a&scoped=true"
import script from "./ManageSubscription.vue?vue&type=script&lang=js"
export * from "./ManageSubscription.vue?vue&type=script&lang=js"

import "./ManageSubscription.vue?vue&type=style&index=0&id=55c3865a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c3865a"]])

export default __exports__